<template>
  <div class="edit-metadata pa-3 mb-4">
    <div class="edit-metadata__row">
      <div v-if="hasVariant" class="edit-metadata__values">
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.availableStock') }}:
        </span>
        <span class="mr-6">{{ availableStock }}</span>
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.wastedStock') }}:
        </span>
        <span>{{ wastedStock }}</span>
      </div>
      <div v-else class="grey--text text--darken-1">
        {{ $t('entities.stockTransactions.selectVariantForDetails') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VariantDetails',
  props: {
    variant: { type: Object, default: () => ({}) },
  },
  computed: {
    hasVariant() {
      if (!this.variant || typeof this.variant !== 'object') return false
      const identifier =
        this.variant.id ?? this.variant.value ?? this.variant.sku ?? null
      return (
        identifier !== null && identifier !== undefined && identifier !== ''
      )
    },
    availableStock() {
      const available = this.variant?.stock?.available
      return this.formatStockValue(available)
    },
    wastedStock() {
      const wasted = this.variant?.stock?.waste
      return this.formatStockValue(wasted)
    },
  },
  methods: {
    formatStockValue(value) {
      if (typeof value === 'number' && !Number.isNaN(value)) {
        return value
      }
      return '-'
    },
  },
}
</script>
